import { useQuery } from "@tanstack/react-query";
import FetchClients, { ClientOutput } from "../client";
import { throwBackpackResponseError } from "../errors";

export type NominationInfo = ClientOutput["rewards"]["Nominator"];
const nomination = {
  useQueryNomination,
} as const;

export default nomination;

function useQueryNomination(nominationToken?: string | null) {
  return useQuery({
    queryKey: ["nominator", nominationToken],
    queryFn: async () => {
      const { data, error } = await FetchClients.rewards.GET("/nominator", {
        params: {
          query: {
            invite: nominationToken!,
          },
        },
      });
      if (data) return data;
      throwBackpackResponseError(error);
    },
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: Boolean(nominationToken),
  });
}
